import {Component, Input, OnDestroy, Renderer2} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { KanbanService } from '../service/kanban.service';
import { Subscription } from 'rxjs';
import {KanbanCard} from "../api/kanban";
import {TieredMenuModule} from "primeng/tieredmenu";
import {ProgressBarModule} from "primeng/progressbar";
import {AvatarGroupModule} from "primeng/avatargroup";
import {AvatarModule} from "primeng/avatar";
import {NgClass, NgFor, NgIf, SlicePipe} from "@angular/common";
import {ButtonDirective} from "primeng/button";
import {Ripple} from "primeng/ripple";
import {TaskStatusIconComponent} from "../../../shared/components/task-status-icon/task-status-icon.component";
import {TaskDetailsSidebarService} from "../../services/task-details-sidebar.service";

@Component({
    selector: 'app-kanban-card',
    standalone: true,
    imports: [
        TieredMenuModule,
        ProgressBarModule,
        AvatarGroupModule,
        AvatarModule,
        NgIf,
        SlicePipe,
        ButtonDirective,
        Ripple,
        NgFor,
        TaskStatusIconComponent,
        NgClass
    ],
    templateUrl: './kanban-card.component.html'
})
export class KanbanCardComponent implements OnDestroy {

    @Input() card!: KanbanCard;

    @Input() listId!: string;

    menuItems: MenuItem[] = [];

    subscription: Subscription;

    constructor(private kanbanService: KanbanService, private renderer: Renderer2, private taskDetailsSidebarService: TaskDetailsSidebarService) {
        this.subscription = this.kanbanService.lists$.subscribe(data => {
            let subMenu = data.map(d => ({ id: d.listId, label: d.title, command: () => this.onMove(d.listId) }));
            this.generateMenu(subMenu);
        })
    }

    parseDate(dueDate: string) {
        return new Date(dueDate).toDateString().split(' ').slice(1, 3).join(' ');
    }

    openDetails() {
        const html = document.querySelector('html');
        if (html) {
            this.renderer.addClass(html, 'no-scrollbar');
        }
        this.taskDetailsSidebarService.isDetailsVisible = true;
    }

    returnStatus() {
        switch (this.listId) {
            case '1':
                this.card.status = "open"
                return 'open'
            case '2':
                this.card.status = "progress"
                return 'progress'
            case '3':
                this.card.status = "review"
                return 'review'
            case '4':
                this.card.status = "blocked"
                return 'blocked'
            case '5':
                this.card.status = "done"
                return 'done'
            default:
                this.card.status = "open"
                return 'open'
        }
    }

    returnPriority() {
        switch (this.card.priority) {
            case 'HIGH':
                return 'pi pi-angle-double-up'
            case 'MEDIUM':
                return 'pi pi-minus'
            case 'LOW':
                return 'pi pi-angle-double-down'
            default:
                return 'pi pi-minus'
        }
    }

    onDelete() {
        this.kanbanService.deleteCard(this.card.id, this.listId);
    }

    onCopy() {
        this.kanbanService.copyCard(this.card, this.listId);
    }

    onMove(listId: string) {
        this.kanbanService.moveCard(this.card, listId, this.listId);
    }

    generateMenu(subMenu: any[]) {
        this.menuItems = [
            { label: 'Copy card', command: () => this.onCopy() },
            { label: 'Move card', items: subMenu },
            { label: 'Delete card', command: () => this.onDelete() }
        ];
    }

    // generateTaskInfo() {
    //     let total = this.card.taskList.tasks.length;
    //     let completed = this.card.taskList.tasks.filter(t => t.completed).length;
    //     return `${completed} / ${total}`;
    // }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
